// extracted by mini-css-extract-plugin
module.exports = {"card":"PatientDetailPanel_card__GSFVB"};